import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { PoType } from '../models/transaction';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TransactionService extends BaseService {
  getCreatedTrans(
    start: string,
    end: string,
    filter: number,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `transaction/created?start=${start}&end=${end}&filter=${filter}`
    ).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProcessedTrans(
    start: string,
    end: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`transaction/in_process?start=${start}&end=${end}`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getSentTrans(
    start: string,
    end: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`transaction/delivering?start=${start}&end=${end}`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getReceivedTrans(
    start: string,
    end: string,
    filter: number,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `transaction/delivered?start=${start}&end=${end}&filter=${filter}`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getTransactionDetail(
    id: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`transaction/${id}`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getPoolOrder(
    start: string,
    end: string,
    status: number,
    offset: number,
    limit: number,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `poolorder?Start=${start}&End=${end}&Status=${status}&Offset=${offset}&Limit=${limit}`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getDetailPoolOrder(
    id: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`poolorder/${id}`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getIconPoType(po_type: PoType): string {
    if (po_type == PoType.CustomerPortal) {
      return 'assets/img/customer-portal.png';
    } else {
      return 'assets/img/call-center.png';
    }
  }

  getPaymentGuideGt(id) {
    return this.getGt(`/api/v1/transaction/panduan-transaction?transactionId=${id}`)
  }

  uploadPaymentProof(
    id: string,
    file: File,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const formData = new FormData();

    formData.append('buktiTransfer', file);
    formData.append('transactionId', id);

    this.postGtMultipartFormData("/api/v1/transaction/upload-bukti-transfer", formData).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getReceivedTransGt(
    start: string,
    end: string,
    filter: number,
    page: number,
    limit: number,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    let params: any = {startDate: start, endDate: end, page: page, limit: limit};
    if (filter != 0) {
      let transactionStatus = filter.toString();
      params.transactionStatus = transactionStatus;
    }
    const httpParams = new HttpParams({ fromObject: params })

    this.getGt(
      `/api/v1/transaction/fetch?${httpParams.toString()}`
    ).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  cancelTransactionGt(
    id: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    let params: any = { transactionId: id };
    this.postGt(
      `/api/v1/transaction/cancel-by-user`,
      params
    ).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }
}
